import { useEffect } from "react";
import { useNavigate } from "react-router";
import useQuery from "./useQuery";

export default function useWizardStep(steps, { param = "step", skip = false, fallback } = {}) {
  const navigate = useNavigate();
  const params = useQuery();
  const rawStep = params.get(param);
  const defaultStep = fallback || steps[0];
  const step = steps.includes(rawStep) ? rawStep : defaultStep;

  useEffect(() => {
    if (skip || step === rawStep) return;
    const newParams = new URLSearchParams(window.location.search);
    newParams.set(param, step);
    navigate({ search: newParams.toString() }, { replace: true });
  }, [skip, step, rawStep, param, navigate]);

  return step;
}
